<template>
  <div>

  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    data: () => {
      return {
        message: [],
      };
    },
    mounted (){
      //console.log('MessageHandler mounted')
    },
    computed: {	
      ...mapGetters( ['getGlobalMessage'] ),	
    },
    methods: {
      ...mapMutations( ['mutateGlobalMessage'] ),
      showMessage() {
        this.$swal.fire({
          toast: this.getGlobalMessage.toast,
          /* position: 'center', */
          position: 'top-end',
          background: (this.getGlobalMessage.toast) ? '#FFFFFF' : '#FFFFFF' ,
          showConfirmButton: ( this.getGlobalMessage.icon == 'error' ) ? true : false ,
          timer: (this.getGlobalMessage.toast) ? 3000 : false ,
          timerProgressBar: this.getGlobalMessage.toast,
          icon: this.getGlobalMessage.icon,
          title: this.getGlobalMessage.title,
          text: this.getGlobalMessage.message,
          showClass: {
            popup: 'animated', // zoomIn
          },
          //background: '#2971f5'
        })        
      }
    },
    watch: {
      'getGlobalMessage': function(newVal, oldVal){
        //console.log('watch getGlobalMessage')
        this.showMessage();

        let message = {};
        message.toast = '';     // true / false
        message.message = '';
        message.icon = '';      // warning, error, success, info, and question

        if( newVal != oldVal && newVal != '' ){
          //this.$store.commit('mutateGlobalMessage', message);
        }
      }
    },
  }
</script>

<!--

watch: {
    colours: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler()
        console.log('The list of colours has changed!');
      }
    }
  }

-->